import { useState } from 'react'

import statisticsAnalytics from '~/analytics/statistics/statisticsAnalytics'

import { WIND_SURFER } from '~/statistics/constants'
import { WindSurferProductStatAPI } from '~/statistics/types/wind-surfer.types'

import ProductCardContainer from '../ProductCardContainer'

import WindSurferSummary from './WindSurferSummary'
import WindSurferDetails from './WindSurferDetails'

export default function WindSurferProductCard({ product }: { product: WindSurferProductStatAPI }): React.ReactElement {
  const [showContent, setShowContent] = useState(false)

  const onToogle = (): void => {
    statisticsAnalytics.logProductCardToggle({ cardName: WIND_SURFER, expanded: !showContent })
    setShowContent(!showContent)
  }

  return (
    <ProductCardContainer>
      <WindSurferSummary onClick={onToogle} showContent={showContent} timeSpent={product.timeSpent} />
      {showContent && <WindSurferDetails product={product} />}
    </ProductCardContainer>
  )
}
